import axios from 'axios'
import { appSettings } from 'settings/app-settings'

export const loginInstance = axios.create({
  baseURL: appSettings.api.REACT_APP_LOGIN_URL,
  withCredentials: true,
})
